import AriesSearch from './AriesSearch';

export default AriesSearch;
